module.exports = __webpack_public_path__ + "static/3-woman-trendy-clothes-49a228499f7438984c88c3ce5ce886e6.jpg";